import { Employee } from '../../types/interfaces';

export function mapEmployeesFromApiResponse(
  value: Employee[] | undefined
): Employee[] {
  if (!value || !Array.isArray(value) || value.length === 0) return [];
  return value.flatMap((x) =>
    x.id && x.fullName
      ? {
        ...x,
        key: x.id.toString(),
        id: x.id,
        label: x.fullName.toString()
      }
      : []
  );
}
